<template>
  <v-carousel
    class="my-carousel"
    :height="$store.state.isSmall ? 220 : 262.66"
    hide-delimiter-background
  >
    <v-carousel-item
      v-for="(img, i) in images"
      :key="i"
    >
      <v-sheet
        height="100%"
      >
        <img class="contain-center" :src="require(`@/assets/img/vehicles/${img}`)" />
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: 'image-carousel',
  props: ['images'],
  data: () => ({
    colors: [
      'indigo',
      'warning',
      'pink darken-2',
      'red lighten-1',
      'deep-purple accent-4',
    ],
    slides: [
      'First',
      'Second',
      'Third',
      'Fourth',
      'Fifth',
    ]
  })
}
</script>

<style lang="scss">

.my-carousel {

  .v-window__next {
    transform: scale(0.9);
    margin: 0 10px;

    i {
      color: #F5542D !important;
    }
  }
  .v-window__prev {
    transform: scale(0.9);
    margin: 0 10px;

    i {
      color: #F5542D !important;
    }
  }
  .v-carousel__controls {
    .v-item-group {
      margin-left: auto;
      margin-right: 15px;

      & > button {
        margin: 0;

      }
      & > button.v-item--active {
        margin: 0;

        i {
          color: #F5542D;
          opacity: 1;
        }
      }
    }
  }
}

</style>